export const normalizePath = pathname => {
  if (!pathname || pathname === '/') return '/';

  const withLeadingSlash = pathname.startsWith('/')
    ? pathname
    : `/${pathname}`;
  const normalized = withLeadingSlash.replace(/\/+$/, '');

  return normalized || '/';
};

export const getCurrentPath = locationObject => {
  const location = locationObject ?? (
    typeof window !== 'undefined' ? window.location : null
  );

  return normalizePath(location?.pathname || '/');
};

export const resolveInitialRoute = (pathname, pageMap) => {
  const path = normalizePath(pathname);

  return {
    path,
    page: pageMap[path] || null,
    isHome: path === '/',
    isNotFound: path !== '/' && !pageMap[path]
  };
};